<template>
  <transition name="fade" mode="out-in">
    <div v-if="isAuthenticated" class="app-container">
      <!-- Se keyea cada vista por la ruta de SU nivel (no por fullPath): así la vista
           persiste al cambiar de flap (solo cambia la ruta hoja) y solo se re-monta al
           cambiar de sección/searcher/persona. El fade del contenido del flap lo hace la
           transición anidada de detail/index.vue → la barra de tabs no parpadea. -->
      <router-view v-slot="{ Component }">
        <component :is="Component" :key="viewKey(Component)" @formDataActionCalled="formDataActionCalled" @definitionError="definitionError" />
      </router-view>
      <transition name="fade" mode="out-in">
        <div v-if="errorMsg" class="popup">
          <div class="w3-modal" @click.prevent>
            <div class="w3-modal-content definition-error">
              <simplebar data-simplebar-auto-hide="false">
                <div class="container">
                  <div>
                    <span class="w3-display-topright close_detail"><i class="sherpa-icon icon-cerrar" @click="popupClose()"></i></span>
                    <div class="w3-container">
                      <div class="w3-row popup-content">
                        <i class="sherpa-icon icon-ico_error"></i> {{ errorMsg }}
                      </div>
                    </div>
                  </div>
                </div>
              </simplebar>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import menu from '@/utils/menu'
import * as appTypes from '@/store/actions/app'
import * as authTypes from '@/store/actions/auth'
import simplebar from 'simplebar-vue'
import 'simplebar-core/dist/simplebar.css'

export default {
  name: 'container',
  props: [
    'type',
    'content'
  ],
  data () {
    return {
      errorMsg: null
    }
  },
  components: {
    simplebar
  },
  mounted () {
  },
  methods: {
    // Key de re-montaje por nivel de ruta: se busca el registro matched cuyo
    // componente es el que este router-view está pintando y se usa su `path`.
    // Estable entre flaps (solo cambia la ruta hoja) → la vista persiste y solo
    // el contenido del flap transiciona; cambia al cambiar de sección/searcher.
    viewKey (Component) {
      const rec = this.$route.matched.find(m => m.components && m.components.default === Component)
      return rec ? rec.path : this.$route.fullPath
    },
    formDataActionCalled (stay) {
      if (!stay) {
        this.goToParentMenu()
      }
    },
    goToParentMenu () {
      var path = this.$route.matched[this.$route.matched.length - 1].path
      var menuParent = menu.methods.getDefaultParentMenuPath(null, this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`], path)
      this.$router.push(menuParent.parentContextPath + menuParent.contextPath).catch(() => {})
    },
    definitionError (error, resultError, container) {
      if (error && resultError) {
        this.errorMsg = resultError.requestErrorMsg
      }
    },
    popupClose () {
      this.errorMsg = null
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`])
  }
}
</script>

<style lang="scss">
#content {
  > .app-container {
    > .container-simplebar {
      position: absolute;
      top: 106px;
      bottom: 62px;
      right: 18px;
      left: 118px;
    }
  }
}
</style>
